import React, { useMemo, useState } from 'react';
import { ImageOff, Minus, Plus } from 'lucide-react';
import RestaurantOverlay from './RestaurantOverlay';
import { formatMoney } from './restaurantUtils';

export default function ProductDetailModal({ product, onClose, onAdd }) {
  const [quantity, setQuantity] = useState(product.cartItem?.quantity || 1);
  const [observation, setObservation] = useState(product.cartItem?.observation || '');
  const total = useMemo(
    () => Number(product.price || 0) * quantity,
    [product.price, quantity]
  );
  const canOrder = product.available && product.restaurantOrderable !== false;

  return (
    <RestaurantOverlay title={`Personalizar ${product.name}`} onClose={onClose} className="rc-product-modal">
      <div className="rc-product-modal__media">
        {product.image_url ? (
          <img src={product.image_url} alt={product.name} />
        ) : (
          <div className="rc-image-fallback"><ImageOff aria-hidden="true" /><span>Sin imagen</span></div>
        )}
      </div>
      <div className="rc-product-modal__content">
        <span className="rc-eyebrow">DETALLE DEL PRODUCTO</span>
        <h2>{product.name}</h2>
        {product.description && <p>{product.description}</p>}
        <strong className="rc-price">{formatMoney(product.price)}</strong>

        <div className="rc-coming-row">
          <div>
            <strong>Opciones y extras</strong>
            <p>Opciones adicionales próximamente.</p>
          </div>
          <span>Próximamente</span>
        </div>

        <label className="rc-field">
          <span>Observaciones para el restaurante</span>
          <textarea
            value={observation}
            onChange={(event) => setObservation(event.target.value.slice(0, 100))}
            maxLength={100}
            placeholder="Ej.: evitar cubiertos si es posible"
          />
          <small>{observation.length}/100</small>
        </label>
      </div>
      <footer className="rc-product-modal__footer">
        <div className="rc-quantity" aria-label="Cantidad">
          <button type="button" disabled={quantity === 1} onClick={() => setQuantity((value) => Math.max(1, value - 1))} aria-label="Reducir cantidad">
            <Minus aria-hidden="true" />
          </button>
          <strong>{quantity}</strong>
          <button type="button" onClick={() => setQuantity((value) => value + 1)} aria-label="Aumentar cantidad">
            <Plus aria-hidden="true" />
          </button>
        </div>
        <button
          type="button"
          className="rc-button rc-button--primary"
          disabled={!canOrder}
          onClick={() => onAdd(product, quantity, observation)}
        >
          {canOrder
            ? `${product.cartItem ? 'Guardar cambios' : 'Agregar'} · ${formatMoney(total)}`
            : product.available ? 'Delivery no disponible' : 'Producto agotado'}
        </button>
      </footer>
    </RestaurantOverlay>
  );
}
